import * as types from '../ActionTypes/BreakdownActionTypes';

export class BreakDownActionCreators {
    static getBreakDownByIdRequest(breakDownId) {
        return {
            type: types.BREAKDOWN_GET_BY_ID_REQUEST,
            meta: { breakDownId },
        };
    }

    static getBreakDownByIdSuccess(response) {
        return {
            type: types.BREAKDOWN_GET_BY_ID_SUCCESS,
            payload: [...response],
        };
    }
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/BreakdownActionCreators.js